module.exports = __webpack_public_path__ + "static/media/table.effc8999.png";